export default __webpack_public_path__ + "assets/south-korea-flag.png";